import React from "react";
import { useParams } from "react-router-dom";
import RootPrivacy from "container/termsAndPrivacy/RootPrivacy";

function PrivacyPage(props) {
  const params = useParams();
  const { language } = params;

  return <RootPrivacy language={language} />;
}

export default PrivacyPage;
